import { Button, Box, Typography, Grid, Divider } from "@mui/material";
import { useNavigate } from "react-router";
import MainCard from "components/MainCard";
import T from "utils/constants/T";
import CashDCard from "components/common/CashDCard";
import "./payrollSettings.css";
import "../../companyDetails.css";
import {
  StyledBodyTypography,
  StyledTitleTypography,
} from "../CompanyTab/CompanyInfo";
import { maskNumber } from "utils/CommonMethods";
import { noop } from "lodash";

interface ViewPayrollSettingsTimeSheetProps {
  includeSubmitted: boolean;
  companyName: string;
  systemName: string;
  apiKey: string;
  userName: string;
  password: string;
  role: string;
  handleSync: () => void;
}
const ViewPayrollSettingsTimeSheet = ({
  includeSubmitted = false,
  companyName = "",
  systemName = "",
  apiKey = "",
  userName = "",
  password = "",
  role = "",
  handleSync = noop,
}: ViewPayrollSettingsTimeSheetProps) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate("/companyDetails/payrollSettings/edit");
  };
  return (
    <MainCard
      title={systemName}
      secondary={
        <>
          <Button
            variant="outlined"
            className="main-card-button"
            onClick={handleSync}
            // startIcon={<CachedIcon />}
          >
            {T.SYNC_PAYROLL}
          </Button>
          &nbsp;&nbsp;&nbsp;
          {(role === "superadmin" || role === "employer")&& (
            <Button
              variant="contained"
              className="main-card-button"
              onClick={handleEdit}
            >
              {T.EDIT}
            </Button>
          )}
        </>
      }
    >
      <CashDCard borderRadius="20px">
        <Grid container rowSpacing={1}>
          <Grid item xs={6}>
            <StyledTitleTypography>{T.API_USERNAME}</StyledTitleTypography>
            <StyledBodyTypography>{userName}</StyledBodyTypography>
          </Grid>
          <Grid item xs={6}>
            <StyledTitleTypography>{T.API_PASSWORD}</StyledTitleTypography>
            <StyledBodyTypography>{maskNumber(password)}</StyledBodyTypography>
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Grid item xs={6}>
              <StyledTitleTypography>{T.API_KEY}</StyledTitleTypography>
              <StyledBodyTypography>{maskNumber(apiKey)}</StyledBodyTypography>
            </Grid>
          </Grid>
        </Grid>
      </CashDCard>
      <CashDCard borderRadius="20px">
        <Box>
          <Typography className="time-sheet-text">
            {T.TIME_SHEETS_STATUS}
          </Typography>
          {!includeSubmitted ? (
            <StyledTitleTypography align="center" mt={1}>
              {T.INCLUDE_SUBMITTED}
            </StyledTitleTypography>
          ) : (
            <StyledTitleTypography align="center" mt={1}>
              {T.DO_NOT_INCLUDE_SUBMITTED}
            </StyledTitleTypography>
          )}
        </Box>
      </CashDCard>
    </MainCard>
  );
};

export default ViewPayrollSettingsTimeSheet;
